import { PackagePlus } from "lucide-react";

// C3 — PULL IT FROM THE ROW. A component still on the truck (or not checked yet) has a Pull it button on its row; it
// opens today's pull already filled in with the component, its values and the photo they were read from.
export const canPullHere = (where) => !where || (["on_truck", "unknown"].includes(where.code) && !where.part_id);

export const pullOf = (c) => ({
  component: c.code, suggestedName: c.label, condition: c.condition, photoId: c.photo_file_id || null,
  componentNumbers: [...(c.fields || []).filter((f) => f.value != null && f.value !== "").map((f) => ({ label: f.label, value: String(f.value) })),
    ...(c.numbers || [])],
});

// The desk button is 48 px tall too, the same as the floor's (his call, 2 Nov); the floor one stays bigger in type.
export function PullButton({ big = false, testid, onClick }) {
  return (
    <button type="button" data-testid={testid} onClick={onClick}
      className={big
        ? "inline-flex items-center gap-2 h-12 px-5 rounded-xl border-2 border-[#B01E28] text-[#B01E28] bg-white font-black text-base hover:bg-red-50"
        : "inline-flex items-center gap-1.5 h-12 min-w-[48px] px-4 rounded-lg border-2 border-[#B01E28] text-[#B01E28] bg-white text-sm font-bold hover:bg-red-50"}>
      <PackagePlus className={big ? "w-5 h-5" : "w-4 h-4"} />Pull it
    </button>
  );
}
